import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { Fxed020RoutingModule } from './fxed020-routing.module';
import { Fxed020S01Component } from './fxed020-s01.component';
import { DwDocumentModule } from '@webdpt/framework';
import { SharedModule } from 'app/implementation/shared/shared.module';

// import { Fxed020GoodsModule } from './fxed020-pages/fxed020-goods/fxed020-goods.module';
// import { Fxed020CarModule } from './fxed020-pages/fxed020-car/fxed020-car.module';
import { Fxed020InfoModule } from './fxed020-pages/fxed020-info/fxed020-info.module';
import { Fxed020QueryModule } from './fxed020-pages/fxed020-querySolutionCenter/fxed020-querySolutionCenter.module';
import { Fxed020HelpcenterComponent } from './fxed020-pages/fxed020-helpCenter/fxed020-helpcenter.component';
import { Fxed020NewsComponent } from './fxed020-pages/fxed020-news/fxed020-news.component';
import { Fxed020NewListComponent } from './fxed020-pages/fxed020-newList/fxed020-newList.component';
import { Fxed020AgentComponent } from './fxed020-pages/fxed020-agent/fxed020-agent.component';
import { Fxed020404Component } from './fxed020-pages/fxed020-404.component';
import { Fxed020StudycenterModule } from './fxed020-pages/fxed020-studycenter/fxed020-studycenter.module';
import { Fxed020SharedModule } from './fxed020-shared/fxed020-shared.module';
import { FooterComponent } from './fxed020-shared/footer/footer.component';
import { FxLoingingService } from 'app/implementation/auth/fx-login.service';
// import { LoginComponent } from 'app/implementation/auth/login/login.component';
import { LoginModule } from 'app/implementation/auth/login.module';
// import { ChangePasswordComponent } from 'app/implementation/shared/layout/dw-tab-routing/change-password/change-password.component';
import { FxEditCellTableComponent } from './fxed020-service/fx-edit-cell-table/fx-edit-cell-table.component';
import { FxCountRowTableComponent } from './fxed020-service/fx-count-row-table/fx-count-row-table.component';
import { Fxed020PayNewComponent } from './fxed020-pages/fxed020-personalCenter/fxed020-personalCenter/fxed020-pay-new/fxed020-pay.component';
import { Fxed020QRcodeComponent } from './fxed020-pages/fxed020-personalCenter/fxed020-personalCenter/fxed020-qrcode/fxed020-qrcode.component';
import { QRCodeModule } from 'angular2-qrcode';
//import { WechatqrcodeModule} from './fxed020-pages/fxed020-personalCenter/fxed020-personalCenter/wechatqrcode/wechatqrcode.module';

@NgModule({
  declarations: [
    Fxed020S01Component,
    // ChangePasswordComponent,
    Fxed020PayNewComponent,
    Fxed020QRcodeComponent,
    //FxCountRowTableComponent,
    // LoginComponent
      //  Fxed020ClassifyComponent,
      //  Fxed020NewsComponent,
      //  Fxed020NewListComponent,
      //  Fxed020HelpcenterComponent,
      //  Fxed020AgentComponent,

      //  Fxed020404Component
      ],
  imports: [
    CommonModule,
    Fxed020RoutingModule,
    SharedModule,
    DwDocumentModule,
    QRCodeModule,
    //WechatqrcodeModule,
    // Fxed020GoodsModule,
    // Fxed020CarModule,
    // Fxed020QueryModule,
    // Fxed020InfoModule,
    // Fxed020StudycenterModule,
    Fxed020SharedModule,
    LoginModule
  ],
  providers: [ //注入器 // 创建对应component\service 实体
    FxLoingingService
  ],
  entryComponents: [
    // ChangePasswordComponent,
    Fxed020PayNewComponent,Fxed020QRcodeComponent],
  exports: []
})
export class Fxed020Module { }
